export function isMobileResolution():boolean {
    return window.screen.width < 992
}
